export default "__VITE_ASSET__D2cN$M2S__"